module.exports = __webpack_public_path__ + "dropify.5a36392239b15ac27438.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendors/by_bower/dropify/dist/fonts/dropify.svg
// module id = ./src/assets/vendors/by_bower/dropify/dist/fonts/dropify.svg
// module chunks = styles